import { Grid, Divider, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import moment from "moment";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AppsIcon from "@mui/icons-material/Apps";

function ViewWalletTransactionForm({ transactionData }) {
  const DetailRow = ({ label, value, icon, customStyle }) => (
    <Grid container spacing={1} sx={{ py: 0.5, alignItems: "center" }}>
      <Grid item xs={0.7} sx={{ display: "flex", alignItems: "center" }}>
        {icon}
      </Grid>
      <Grid item xs={3.3}>
        <MDTypography variant="button" fontWeight="medium" color="text">
          {label}
        </MDTypography>
      </Grid>
      <Grid item xs={8}>
        <MDTypography
          variant="button"
          fontWeight="regular"
          sx={{
            backgroundColor: customStyle?.backgroundColor || "grey.100",
            py: 0.5,
            px: 1,
            borderRadius: 1,
            display: "block",
            ...customStyle,
          }}
        >
          {value}
        </MDTypography>
      </Grid>
    </Grid>
  );

  const getTransactionTypeStyle = (type) => {
    if (type === "Credit") {
      return {
        backgroundColor: "rgba(99, 185, 103, 0.1)",
      };
    } else if (type === "Debit") {
      return {
        backgroundColor: "rgba(244, 67, 53, 0.1)",
      };
    }
    return {};
  };

  return (
    <MDBox>
      <Card sx={{ px: 2, boxShadow: "none" }}>
        <DetailRow
          label="Transaction ID"
          value={transactionData.transaction_id}
          icon={<ReceiptIcon color="primary" sx={{ fontSize: 20 }} />}
        />
        <DetailRow
          label="Transaction Type"
          value={transactionData.transaction_type}
          icon={<CompareArrowsIcon color="primary" sx={{ fontSize: 20 }} />}
          customStyle={getTransactionTypeStyle(transactionData.transaction_type)}
        />

        <Divider sx={{ my: 1 }} />

        <DetailRow
          label="Amount"
          value={
            transactionData?.amount ? `$${parseFloat(transactionData?.amount).toFixed(2)}` : "-"
          }
          icon={<AttachMoneyIcon color="primary" sx={{ fontSize: 20 }} />}
        />
        {transactionData?.actual_cost !== undefined &&
          transactionData?.actual_cost !== null &&
          transactionData?.actual_cost !== "" && (
            <DetailRow
              label="Actual Amount"
              value={
                transactionData?.actual_cost
                  ? `$${parseFloat(transactionData?.actual_cost).toFixed(4)}`
                  : "-"
              }
              icon={<AttachMoneyIcon color="primary" sx={{ fontSize: 20 }} />}
            />
          )}

        {transactionData?.transaction_module && (
          <DetailRow
            label="Module"
            value={transactionData.transaction_module}
            icon={<AppsIcon color="primary" sx={{ fontSize: 20 }} />}
          />
        )}

        {transactionData.card_number && (
          <DetailRow
            label="Card Number"
            value={`****${transactionData.card_number}`}
            icon={<CreditCardIcon color="primary" sx={{ fontSize: 20 }} />}
          />
        )}

        <Divider sx={{ my: 1 }} />

        {transactionData?.user?.first_name && (
          <DetailRow
            label="User"
            value={`${transactionData?.user?.first_name || ""} ${
              transactionData?.user?.last_name || ""
            }`}
            icon={<PersonIcon color="primary" sx={{ fontSize: 20 }} />}
          />
        )}

        <DetailRow
          label="Created At"
          value={moment(transactionData.created_at).format("MMM DD, YYYY [at] hh:mm:ss A")}
          icon={<AccessTimeIcon color="primary" sx={{ fontSize: 20 }} />}
        />
      </Card>
    </MDBox>
  );
}

export default ViewWalletTransactionForm;
